<template>
  <div class="relative inline-block">
    <!-- Price-sticker silhouette: SVG sized to fill its parent and stretched
         non-uniformly so the notches in the middle of the short edges stay
         visible whatever width the label needs. -->
    <svg
      aria-hidden="true"
      class="absolute inset-0 h-full w-full"
      fill="none"
      preserveAspectRatio="none"
      viewBox="16 27 64 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 28C20 27.4477 20.4477 27 21 27H75C75.5523 27 76 27.4477 76 28V30.3944C76 30.7893 76.1152 31.172 76.3239 31.5072C77.2761 33.0363 80 37.6991 80 41C80 44.3009 77.2761 48.9637 76.3239 50.4928C76.1152 50.828 76 51.2107 76 51.6056V54C76 54.5523 75.5523 55 75 55H21C20.4477 55 20 54.5523 20 54V51.6056C20 51.2107 19.8848 50.828 19.6761 50.4928C18.7238 48.9636 15.9998 44.3008 16 41C16.0002 37.6991 18.724 33.0363 19.6761 31.5072C19.8848 31.172 20 30.7893 20 30.3945V28Z"
        fill="#334EFB"
      />
    </svg>
    <p :class="['relative', sizeClasses]" style="color: #ffffff">
      {{ displayLabel }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { Price } from '@backmarket/http-api/src/api-models/Price'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { tw } from '@backmarket/utils/string/tw'

const props = withDefaults(
  defineProps<{
    // Either a monetary price (formatted via i18n) or a plain text label such
    // as a discount string ("-30%"). Exactly one is expected.
    price?: Price
    label?: string
    size?: 'small' | 'large'
  }>(),
  { size: 'large', price: undefined, label: undefined },
)

const i18n = useI18n()

const displayLabel = computed(
  () =>
    props.label ??
    (props.price ? i18n.price(props.price, { maximumFractionDigits: 0 }) : ''),
)

const sizeClasses = computed(() =>
  props.size === 'small'
    ? tw`body-2-bold px-12 py-2`
    : tw`heading-3 px-16 py-8`,
)
</script>
